import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=32c2c282&"
import script from "./navigation.vue?vue&type=script&lang=js&"
export * from "./navigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports